module.exports = __webpack_public_path__ + "img/class_logo.96f2bb8c.png";